import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS,
	},
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET,
	},
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW,
	},
}
